import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
// The original did `import * as $ from 'jquery'` (the bundled jquery module instance, NOT the
// global window.$) and registered intl-tel-input on that instance via its CommonJS branch
// (`require("jquery")`). A default import yields the same callable module instance under
// esbuild, where a namespace import of a CommonJS module is not callable.
import $ from 'jquery';
import 'intl-tel-input';
// Patched local copy of 'intl-tel-input/build/js/utils' (see header of that file).
import './intl-tel-input-utils.js';

@Directive({
  selector: '[ng2TelInput]',
  standalone: false
})
export class Ng2TelInput implements OnInit {
  @Input('ng2TelInputOptions') ng2TelInputOptions: any;
  @Output('hasError') hasError: EventEmitter<boolean> = new EventEmitter();
  @Output('ng2TelOutput') ng2TelOutput: EventEmitter<any> = new EventEmitter();
  @Output('countryChange') countryChange: EventEmitter<any> = new EventEmitter();
  @Output('intlTelInputObject') intlTelInputObject: EventEmitter<any> = new EventEmitter();
  ngTelInput: any;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.ngTelInput = ($ as any)(this.el.nativeElement);
    if (this.ng2TelInputOptions) {
      this.ngTelInput.intlTelInput(this.ng2TelInputOptions);
    } else {
      this.ngTelInput.intlTelInput();
    }

    this.ngTelInput.on('countrychange', (e: any, countryData: any) => {
      this.countryChange.emit(countryData);
    });

    this.intlTelInputObject.emit(this.ngTelInput);
  }

  @HostListener('blur') onBlur(): void {
    const isInputValid: boolean = this.isInputValid();
    if (isInputValid) {
      const telOutput = this.ngTelInput.intlTelInput('getNumber');
      this.hasError.emit(isInputValid);
      this.ng2TelOutput.emit(telOutput);
    } else {
      this.hasError.emit(isInputValid);
    }
  }

  isInputValid(): boolean {
    return this.ngTelInput.intlTelInput('isValidNumber') ? true : false;
  }

  setCountry(country: any): void {
    this.ngTelInput.intlTelInput('setCountry', country);
  }
}
